// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3BRnf","actions":"GroupTable_actions__MMrV2","deleteModalFooter":"GroupTable_deleteModalFooter__12QdZ"};